import $ from 'jquery';

var customSpin = function($el) {
    var $input = $el.find('input').first(),
        $dec = $el.find('.decrement').first(),
        $inc = $el.find('.increment').first(),
        interval = $el.data('interval') || 1;

    var decrement = function (){
        $input.val($input.val() - interval);
        $input.trigger('change');
    };
    var increment = function (){
        $input.val($input.val() - (-interval));
        $input.trigger('change');
    };

    $dec.on('click', decrement);
    $inc.on('click', increment);
    return $el;
};

$.fn.customspin = function() {
    for (var i = 0; i < this.length; i++) {
        customSpin($(this[i]));
    }
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/custom-spin.js
 **/